/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserProfilePrivateRequest } from './UserProfilePrivateRequest';
import {
    UserProfilePrivateRequestFromJSON,
    UserProfilePrivateRequestFromJSONTyped,
    UserProfilePrivateRequestToJSON,
} from './UserProfilePrivateRequest';

/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * 
     * @type {UserProfilePrivateRequest}
     * @memberof UserCreateRequest
     */
    profile?: UserProfilePrivateRequest;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof UserCreateRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    last_name: string;
}

/**
 * Check if a given object implements the UserCreateRequest interface.
 */
export function instanceOfUserCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function UserCreateRequestFromJSON(json: any): UserCreateRequest {
    return UserCreateRequestFromJSONTyped(json, false);
}

export function UserCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile': !exists(json, 'profile') ? undefined : UserProfilePrivateRequestFromJSON(json['profile']),
        'username': json['username'],
        'password': json['password'],
        'email': json['email'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function UserCreateRequestToJSON(value?: UserCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile': UserProfilePrivateRequestToJSON(value.profile),
        'username': value.username,
        'password': value.password,
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

